module.exports = __webpack_public_path__ + "img/load.94ac2838.svg";